module.exports = __webpack_public_path__ + "img/16.8294cd93.jpg";